export enum AvailLANG {
  EN = "EN",
  TC = "TC",
  SC = "SC",
}
